<script module>
  export const meta = {
    title: 'Alternative Movements',
    teaser:
      'On the session page, select "Alternative Movements" to customize exercises based\non your needs. Adjust for restrictions like "Exclude floor movements" or "Tight\npants mode." This personalization affects only your session, not others\'.',
    sort: 1,
  }
</script>

<p>
  On a session page, you're given the flexibility to select "Alternative
  Movements." This feature tailors a unique set of movements to accommodate your
  specific needs or limitations.
</p>
<blockquote>
  <p>
    Remember, it's possible to adjust your restrictions and equipment at any
    point, even mid-session.
  </p>
</blockquote>
<p>
  Currently, you can apply the following restrictions to personalize your
  experience:
</p>
<ul>
  <li>Exclude floor movements</li>
  <li>Tight pants or skirt mode</li>
  <li>Only movements for sitting</li>
  <li>Train, Bus or Airplane mode</li>
  <li>Only stretches</li>
</ul>
<p>
  It's important to note that applying a restriction modifies the session
  uniquely for you. Other participants in the session will continue with the
  standard set of movements. As a result, if anyone has enabled an alternative
  movement setting, the exercises you perform may differ from those of other
  participants.
</p>
